import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
})
export class TruncatePipe implements PipeTransform {
  transform(
    value: string,
    limit = 50,
    completeWords = false,
    ellipsis = '...',
    minScreenWidth = 768
  ): string {
    if (!value) {
      return '';
    }

    const screenWidth = window.innerWidth;

    // If the screen width is larger than the threshold, return the full text
    if (screenWidth > minScreenWidth) {
      return value;
    }

    // Otherwise, truncate the text
    if (completeWords) {
      limit = value.substring(0, limit).lastIndexOf(' ');
    }
    return value.length > limit ? value.substring(0, limit) + ellipsis : value;
  }
}
